/*
 * Customs User Role History Service
 * !== 세관 사용자 권한 이력 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { comnUtils } from "@/comn/utils";
import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

export const BASE = {
    path: `${ptlEnvs.base}/ptl/cotp-auth`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/cotp-auth`,
    nodes: [],
};



/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {

    getCoTpAuthList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),

    getCoTpMenuAuthList: (id: any, page: number, size: number) =>
        api.get(`${BASE.api}/${id}?page=${page}&size=${size}`),

    // Save
    saveCoTpAuth: (data: any) => {
        return api.post(`${BASE.api}/save-auths`, data); // <- send array directly
    },

    // Delete
    deleteCoTpAuth: (data: any) => {
        return api.put(`${BASE.api}`, data);
    },
};

export const URLS = {
    ptli1008008q: `${BASE.path}/ptli1008008q`,
    ptli1008012q: `${BASE.path}/ptli1008012q`,
    ptli1008013s: `${BASE.path}/ptli1008013s`,
};

export const SF_CO_TP_SRCH: TFormSchema = {
    id: "form_coTpSrch",
    schema: {
        coTpCd: {
            label: "L_CO_TP_CD",
            type: "select",
            area: "comnCd",
            comnCd: "COM0011",
            all: true,
            editType: "both",
        },
    },
};

export const SF_AUTH_MENU_LIST: TFormSchema = {
    id: "form_coTpMenuAuth",
    schema: {
        coTpCd: { type: "text", label: "L_CO_TP_CD", letterCase: "upper" },
        authId: { type: "text", label: "L_AUTH_ID", letterCase: "upper" },
    },
};


export const SG_CO_TP_LIST: TGridSchema = {
    id: "grid_CoTpAuthList",
    options: { index: true, checkbox: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "*" }] },
        { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "*" }] },
        { cells: [{ header: "L_AUTH_DESC", binding: "authDesc", width: "*" }] },
    ],
    body: [

        { cells: [{ binding: "authId" }] },
        { cells: [{ binding: "authNm" }] },
        { cells: [{ binding: "authDesc" }] },
    ],
};

export const SG_MENU_LIST: TGridSchema = {
    id: "grid_CoTpMenuAuthList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_MENU_ID", binding: "menuId", width: "*" }] },
        { cells: [{ header: "L_MENU_NM", binding: "menuNm", width: "*" }] },
    ],
    body: [

        { cells: [{ binding: "menuId" }] },
        { cells: [{ binding: "menuNm" }] },
    ],
};


